<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.NEWS' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.NEWS_LIST' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage"  style="margin-right:6px !important">{{ 'MENU.DASHBOARD.show' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm "
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="mx-1">{{ 'MENU.DASHBOARD.entries' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">{{ 'MENU.DASHBOARD.search' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.search' | translate }}"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
<ngx-datatable 
  class="bootstrap core-bootstrap bg-white"
  [rows]="pages"
  [columnMode]="ColumnMode.force"
  [headerHeight]="45"
  [rowHeight]="60"
  [footerHeight]="50"
  [limit]="itemsPerPage"
  [scrollbarH]="true"
  [messages]="messages">

   <!-- 🔢 Serial Number -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.serial_number' | translate }}"
  [width]="100">
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
    {{ rowIndex + 1 }}
  </ng-template>
</ngx-datatable-column>


<!-- 🖼 Icon / Image -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.image' | translate }}"
  [width]="150"
>
  <ng-template ngx-datatable-cell-template let-row="row">
    <ng-container *ngIf="row.main_image; else noImage">
      <img
        [src]="row.main_image"
        alt="icon"
        width="40"
        height="40"
        style="object-fit: contain"
      />
    </ng-container>
    <ng-template #noImage>
      <span class="text-muted">-</span>
    </ng-template>
  </ng-template>
</ngx-datatable-column>


<!-- 📰 Title -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.title' | translate }}"
  prop="title"
  [width]="150">
    <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.title ? (row.title | slice:0:10) + '...' : '-' }}
  </ng-template>
</ngx-datatable-column>




<!-- 📝 Content -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.content' | translate }}"
  [width]="200">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.content ? (row.content | slice:0:20) + '...' : '-' }}
  </ng-template>
</ngx-datatable-column>


          <!-- Actions -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" prop="actions" [flexGrow]="1" [sortable]="false">
  <ng-template ngx-datatable-cell-template let-row="row">
    <div class="d-flex align-items-center">
      <div ngbDropdown container="body" class="btn-group">
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
          [id]="'dropdownActions_' + row.id"
        >
          <i data-feather="more-vertical"></i>
        </button>

        <div
          ngbDropdownMenu
          class="dropdown-menu dropdown-menu-right"
          [attr.aria-labelledby]="'dropdownActions_' + row.id"
        >


<!-- Related News Button -->
    <button class="dropdown-item" (click)="openRelatedNewsModal(row.id)">
      <i data-feather="link" class="me-2"></i>
      {{ 'MENU.DASHBOARD.related_news' | translate }}
    </button>
     <!-- Edit Button -->
      <button
        class="dropdown-item w-100"
        ngbDropdownItem
        (click)="editProduct(row.id)"
      >
        <i data-feather="edit" class="mr-50 mx-2"></i>
        {{ 'MENU.DASHBOARD.investor_edit' | translate }}
      </button>

          <button
            class="dropdown-item text-danger w-100"
            ngbDropdownItem
  (click)="confirmDelete(row.id)"
          >
            <i data-feather="trash" class="mr-50 mx-2"></i>
             {{ 'MENU.DASHBOARD.investor_delete' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ngx-datatable-column>



      </ngx-datatable>


       
      </section>
    </div>
  </div>

      <!-- Pagination component -->
<div class="mt-3">
  <app-new-pagination
    *ngIf="totalItems > itemsPerPage"
    [currentPage]="currentPage"
    [totalItems]="totalItems"
    [itemsPerPage]="itemsPerPage"
    [maxPagesToShow]="8"
    (pageChange)="onPageChange($event)">
  </app-new-pagination>
</div>
  
  <!-- Related News Modal -->
<ng-template #relatedNewsModal let-modal>

      <!-- Header -->
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title fw-bold">
          {{ 'MENU.DASHBOARD.select_related_news' | translate }}
        </h5>
        <!-- Custom Close -->
        <button
          type="button"
          class="btn btn-light btn-sm rounded-circle"
          (click)="modal.dismiss()"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <label class="form-label fw-semibold mb-2">
          {{ 'MENU.DASHBOARD.related_news' | translate }}
        </label>
    <div class="list-group max-h-64 overflow-auto">
  <label
    class="list-group-item d-flex justify-content-between align-items-center"
    *ngFor="let news of pages"
  >
    <span>{{ news.title }}</span>
    <input
      type="checkbox"
      [checked]="selectedNewsIds.includes(news.id)"
      (change)="onSelectNews($event, news.id)"
    />
  </label>
</div>

      </div>

      <!-- Footer -->
      <div class="modal-footer border-top-0">
        <button class="btn btn-secondary" (click)="modal.dismiss()">
          {{ 'MENU.DASHBOARD.cancel' | translate }}
        </button>
        <button class="btn bg-success" (click)="saveRelatedNews(modal)" style="background-color: #cca44c !important; color: #fff;">
          {{ 'MENU.DASHBOARD.save' | translate }}
        </button>
      </div>

</ng-template>
